export default __webpack_public_path__ + "cloud_bg.jpg?1fd97eaeb4a28b6bc9607d4fc2df7174";